import React from 'react';
import classNames from 'classnames';
import { Arrow } from '@components/common';
import styles from './index.less';
import { tid } from '@utils/test';
import { StyledTag, TagWrapper } from './styled';

const LESS_THAN_000_1 = ' < 0.001';
const GREATER_THAN_1000 = ' > 1000';

export const TREND_NEW = 'New';
export const TREND_SAME = 'Same';
export const TREND_NA = '-';

const ARROW_UP = 'up';
const ARROW_DOWN = 'down';

const SPECIAL_DISPLAY_VALUES = [TREND_NEW, TREND_SAME];

function getDisplayedValue(value, precision = 1) {
  if (SPECIAL_DISPLAY_VALUES.includes(value)) {
    return value;
  }

  if (value === null || isNaN(value)) {
    return TREND_NA;
  }

  const multiplier = 10 ** precision;
  const mul = Math.round(Math.abs(value) * 100 * multiplier) / multiplier;
  if (mul < 0.001) {
    return TREND_SAME; // consider diff as 0
  }
  if (mul > 1000) {
    return GREATER_THAN_1000;
  }
  return `${mul}`;
}

const getNoChangeText = () => {
  const classString = classNames(styles.trend);
  return (
    <div className={classString}>
      <span>{'-'}</span>
    </div>
  );
};

const Trend = ({ value, reverse, precision, style = {} }) => {
  const flag = value < 0 ? ARROW_DOWN : ARROW_UP;
  const type =
    (flag === ARROW_UP && !reverse) || (flag === ARROW_DOWN && reverse) ? ARROW_UP : ARROW_DOWN;

  const displayValue = `${getDisplayedValue(value, precision)}`;

  // special cases
  if (SPECIAL_DISPLAY_VALUES.includes(displayValue)) {
    const specialColor =
      displayValue === TREND_SAME ? 'default' : type === ARROW_UP ? 'green' : 'red';
    return (
      <TagWrapper style={style} {...tid(`trend-${flag}`)}>
        <StyledTag color={specialColor}>{displayValue}</StyledTag>
      </TagWrapper>
    );
  }

  // no valid value
  if ([TREND_NA].includes(displayValue)) {
    return getNoChangeText();
  }

  const classString = classNames(styles[type], styles.trend);

  return (
    <div className={classString} style={style} {...tid(`trend-${flag}`)}>
      <span>{`${displayValue}%`}</span>
      <Arrow green={type === ARROW_UP} up={value >= 0} />
    </div>
  );
};

Trend.defaultProps = {
  value: '-',
  reverse: false,
  className: '',
  precision: 1,
};

export default Trend;
